import { apiFetch, setParticipantToken, clearParticipantToken } from './api';

export interface JoinRequest {
  /** Nome gara (stesso valore del query `?session=` nel link). */
  session: string;
  name: string;
  email: string;
  slot?: number;
}

export interface JoinResponse {
  token: string;
  participant: {
    id: string;
    session_id: string;
    slot: number;
    name: string;
    color: string;
    email: string;
  };
}

export async function joinAsParticipant(req: JoinRequest): Promise<JoinResponse> {
  const data = await apiFetch<JoinResponse>('/api/auth/participant-join', {
    method: 'POST',
    body: JSON.stringify(req),
  });
  setParticipantToken(data.token);
  return data;
}

export function leaveParticipant(): void {
  clearParticipantToken();
}

export interface DecodedParticipantToken {
  session_id: string;
  participant_id: string;
  slot: number;
  exp: number;
}

export function decodeParticipantToken(token: string): DecodedParticipantToken | null {
  try {
    const [, payload] = token.split('.');
    if (!payload) return null;
    const normalized = payload.replace(/-/g, '+').replace(/_/g, '/');
    const json = atob(normalized.padEnd(Math.ceil(normalized.length / 4) * 4, '='));
    return JSON.parse(json) as DecodedParticipantToken;
  } catch {
    return null;
  }
}
